// Lib
import React from 'react';
import { useTranslator } from '../../components/i18n/useTranslator';

// Components
import FullScreenErrorModal from '../../components/modal/FullScreenErrorModal';
import ModalActionsList from '../../components/modal/ModalActionsList';

const PlatformCookieFullScreenWarning = () => {
    const translate = useTranslator('modal', 'platform.cookies');

    return (
        <FullScreenErrorModal>
            <h2>{translate('title')}</h2>
            <p className="explanation">
                {translate('description')}
            </p>
            <ModalActionsList actions={[{ text: translate('findOutMoreLink'), href: 'http://www.whatarecookies.com/' }]} />
        </FullScreenErrorModal>
    );
};

PlatformCookieFullScreenWarning.propTypes = {};

export default PlatformCookieFullScreenWarning;
